module.exports = __webpack_public_path__ + "static/media/ingredient.721873d2.svg";